module.exports = __webpack_public_path__ + "img/co2.f3526767.png";